import React, { memo, useCallback } from "react";
const KPIPagination = memo(({ currentPage, totalPages, onPageChange }) => {
  const getPageNumbers = useCallback(() => {
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    
    if (totalPages <= 7) return pages;
    
    if (currentPage <= 3) {
      return [...pages.slice(0, 5), '...', totalPages];
    } else if (currentPage >= totalPages - 2) {
      return [1, '...', ...pages.slice(totalPages - 5)];
    } else {
      return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
    }
  }, [currentPage, totalPages]);

  const PaginationButton = memo(({ onClick, disabled, active, children }) => (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`px-3 py-1 rounded-md transition-colors ${
        disabled 
          ? 'text-gray-400 cursor-not-allowed' 
          : active
            ? 'bg-[#3985b6] text-white'
            : 'text-gray-700 hover:bg-gray-100'
      }`}
    >
      {children}
    </button>
  ));

  return (
    <div className="flex justify-between items-center mt-4 px-4 py-2 bg-white border rounded-md">
      <div className="text-sm text-gray-600">
        Page {currentPage} of {totalPages}
      </div>
      
      <div className="flex space-x-1">
        <PaginationButton
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </PaginationButton>
        
        {getPageNumbers().map((page, index) => (
          <PaginationButton
            key={index}
            onClick={() => typeof page === 'number' ? onPageChange(page) : null}
            active={page === currentPage}
            disabled={typeof page !== 'number'}
          >
            {page}
          </PaginationButton>
        ))}
        
        <PaginationButton
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </PaginationButton>
      </div>
    </div>
  );
});

export default KPIPagination;